import { RecordListFilter } from './components/record-list-filter';
import { PageLayout } from '~/components/PageLayout/PageLayout';
import { useAuthentication } from '~/hooks/useAuthentication';
import { RecordList } from './components/record-list';
import { Button } from '~/components/Button/Button';
import { Fragment } from 'react/jsx-runtime';
import { Link } from 'react-router';

export function Page() {
  const { can } = useAuthentication();

  return (
    <Fragment>
      <PageLayout.Header>
        <PageLayout.Heading text="Lista av rekord" />

        {can('manage-records') && (
          <Link to="manage">
            <Button type="button">Hantera rekord</Button>
          </Link>
        )}
      </PageLayout.Header>

      <PageLayout.Section>
        <RecordListFilter />
        <RecordList />
      </PageLayout.Section>
    </Fragment>
  );
}
